import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AngularFireAuthGuard } from "@angular/fire/compat/auth-guard";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { RouterModule, Routes } from "@angular/router";

import { IonicModule } from "@ionic/angular";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import player from 'lottie-web';
import { LottieComponent, provideLottieOptions } from "ngx-lottie";
import { ComponentModule } from "src/app/components/component.module";
import { PageNotFoundPageComponent } from "src/app/components/page-not-found-page/page-not-found-page.component";
import { DirectiveModule } from "src/app/directives/directive.module";
import { AuthGuard } from "src/app/guard/auth.guard";

import { StoreDataResolverService } from "src/app/services/store-data-resolver.service";
import { TabsFirestoreService } from "src/app/services/tabs-firestore.service";
import { SwiperModule } from "swiper/angular";
import { AddCardComponent } from "./add-card/add-card.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { CreditCheckoutComponent } from "./credit-checkout/credit-checkout.component";
import { OfferOfDayDetailComponent } from "./offerOfDayDetail/offerOfDayDetail.component";
import { PickOfferComponent } from "./pick-an-offer/pick-an-offer.component";
import { ProductAnimationComponent } from "./product-animation/product-animation.component";
import { ProductInfoComponent } from "./product-info/product-info.component";
import { ProductComponent } from "./product/product.component";
import { RedirectUriComponent } from "./redirect-uri/redirect-uri.component";
import { StoreJackpotBottomsheetComponent } from "./store-jackpot-bottomsheet/store-jackpot-bottomsheet.component";
import { StorePaymentComponent } from "./store-payment/store-payment.component";
import { StorePage } from "./store.page";
import { TriggersComponent } from "./triggers/triggers.component";
import { CheckoutTryAgainComponent } from "./checkout-try-again/checkout-try-again.component";
import { StoreSwiperManagerService } from "./services/store-swiper-manager.service";
import { StoreNotificationService } from "./services/store-notification.service";
import { StoreJackpotTriggerFacadeService } from "./services/store-jackpot-trigger-facade.service";
import { ProductPaymentFacadeService } from "./services/product-payment-facade.service";
import { ProductDrawDayUtility } from "./services/product-draw-day.utility";

// export function playerFactory() {
//   return import("lottie-web");
// }

export function FirestoreTranslationsLoaderFactory() {
  return new TabsFirestoreService();
}

const routes: Routes = [
  {
    path: "",
    component: StorePage,
  },
  {
    path: "products/:product",
    component: ProductComponent,
    resolve: {
      data: StoreDataResolverService,
    },
    canActivate: [AngularFireAuthGuard, AuthGuard],
  },
  {
    path: "triggers",
    component: TriggersComponent,
  },
  {
    path: "checkout",
    component: StorePaymentComponent,
  },
  {
    path : "checkout-try-again",
    component : CheckoutTryAgainComponent
  },
  {
    path: "addnew/:time",
    component: AddCardComponent,
    canActivate: [AngularFireAuthGuard, AuthGuard],
  },
  {
    path: "r",
    component: RedirectUriComponent,
  },
  {
    path: "custom-offer",
    component: PickOfferComponent,
    canActivate: [AngularFireAuthGuard, AuthGuard],
  },
  {
    path: "credit-checkout",
    component: CreditCheckoutComponent,
  },
  { path: "**", component: PageNotFoundPageComponent },
];

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    SwiperModule,
    ComponentModule,
    ReactiveFormsModule,
    DirectiveModule,
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: FirestoreTranslationsLoaderFactory,
        },
        defaultLanguage: "en",
        isolate: true,
        extend: true,
    }),
    LottieComponent,
    StorePage,
    ProductComponent,
    ProductInfoComponent,
    OfferOfDayDetailComponent,
    CheckoutComponent,
    TriggersComponent,
    StorePaymentComponent,
    AddCardComponent,
    ProductAnimationComponent,
    StoreJackpotBottomsheetComponent,
    CreditCheckoutComponent,
    CheckoutTryAgainComponent
],
    providers: [
        StoreDataResolverService,
        StoreSwiperManagerService,
        StoreNotificationService,
        StoreJackpotTriggerFacadeService,
        ProductPaymentFacadeService,
        ProductDrawDayUtility,
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
        provideLottieOptions({
            player: () => player,
        }),
    ],
    exports: [StorePaymentComponent, CheckoutTryAgainComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StorePageModule {}
